module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/team-4-1ef03972d4a48d33629197faadf890fd.png";